<div class="container-fluid mt-3">
    <div class="card">
        <div class="card-header"><strong>{{ pageTitle }}</strong></div>
        <div class="card-body">
            <wj-menu *ngIf="!fixedMaster" #masterMenu [value]="shortname" [header]="'kobeac.master_name' | transloco" (itemClicked)="onMasterMenu(masterMenu)">
                <wj-menu-item *ngFor="let m of menus" [value]="m">{{ masterLabel(m) | transloco }}</wj-menu-item>
            </wj-menu>
            <tabset class="d-block mt-2">
                <tab [heading]="'kobeac.tab_list' | transloco">
                    <div class="row my-2">
                        <div class="col-md-3">
                            <wj-menu [(value)]="readonly" [header]="'kobeac.edit_mode' | transloco" [isDisabled]="cv && cv.hasChanges()">
                                <wj-menu-item [value]="true">{{ 'kobeac.lock' | transloco }}</wj-menu-item>
                                <wj-menu-item [value]="false">{{ 'kobeac.editable' | transloco }}</wj-menu-item>
                            </wj-menu>
                            <span class="ml-2">{{ 'kobeac.n_hits' | transloco: {count: (cv ? (cv.totalCount | number) : 0)} }}</span>
                        </div>
                        <div class="col-md-3"><button (click)="export()" class="btn btn-primary btn-block">{{ 'kobeac.export' | transloco }}</button></div>
                    </div>
                    <wj-flex-grid #grid class="ap-readonly-tint" *ngIf="cv" [itemsSource]="cv" [isReadOnly]="readonly" [allowAddNew]="!readonly"
                                  [allowDelete]="!readonly" [itemFormatter]="itemFormatter" [selectionMode]="'CellRange'"
                                  style="max-height:400px;min-height:400px">
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <ng-template wjFlexGridCellTemplate [cellType]="'RowHeader'" let-row="row">
                            <span *ngIf="isEdited(row)">{{ 'kobeac.row_edited' | transloco }}</span><span *ngIf="isNew(row)">{{ 'kobeac.row_new' | transloco }}</span>
                        </ng-template>
                        <wj-flex-grid-column *ngFor="let col of columns" [header]="'kobeac.' + col.key | transloco" [binding]="col.binding"
                                             [width]="col.width || 120" [dataType]="col.dataType || 'String'"
                                             [format]="col.format || ''" [dataMap]="dataMapFor(col.dataMap)"
                                             [isRequired]="false"></wj-flex-grid-column>
                    </wj-flex-grid>
                    <div class="d-flex align-items-center mt-2" *ngIf="cv">
                        <wj-menu [(value)]="cv.pageSize" [header]="'kobeac.page_size' | transloco">
                            <wj-menu-item [value]="10">10</wj-menu-item>
                            <wj-menu-item [value]="30">30</wj-menu-item>
                            <wj-menu-item [value]="100">100</wj-menu-item>
                            <wj-menu-item [value]="500">500</wj-menu-item>
                            <wj-menu-item [value]="1000">1000</wj-menu-item>
                            <wj-menu-item [value]="5000">5000</wj-menu-item>
                        </wj-menu>
                        <wj-collection-view-navigator class="ml-2" [cv]="cv" [byPage]="true" [headerFormat]="'{currentPage:n0} / {pageCount:n0}'"></wj-collection-view-navigator>
                    </div>
                    <button *ngIf="!readonly && cv" [disabled]="!cv.hasChanges()" (click)="saveChanges()" class="btn btn-primary btn-block btn-lg mt-2">{{ 'kobeac.save_changes' | transloco }}</button>
                    <button *ngIf="!readonly && cv" [disabled]="!cv.hasChanges()" (click)="cancelChanges()" class="btn btn-secondary btn-block btn-lg">{{ 'common.cancel' | transloco }}</button>
                </tab>
                <tab [heading]="'kobeac.tab_settings' | transloco">
                    <kobeac-column-settings class="d-block mt-3" [grid]="grid"></kobeac-column-settings>
                </tab>
            </tabset>
        </div>
    </div>
</div>
